module.exports = __webpack_public_path__ + "img/parts_default.dfb2ff40.png";